export default "__VITE_ASSET__tmqgkjGC__"